<script lang="ts">
    import { onMount } from 'svelte'

    import type { Field } from '../../types/Field'
    import type { State } from '../../types/State'
    import Section from './Section.svelte'

    export let path: [number]

    export let state: State

    export let simpleLanguage = false

    $: {
        if (path) {
            window.scrollTo(0, 0)
            location.href = `#handlungsfeld-${path[0] + 1}`
        }
    }

    export let field: Field
</script>

{#if !simpleLanguage}
    <div class:icon={field.icon} style="--icon:url('{field.icon}')">
        <h2>
            <span>Handlungsfeld {path[0] + 1} – </span>
            {#if field.title}
                {field.title}
            {/if}
        </h2>
        {#if field.description}
            <p>{field.description}</p>
        {/if}
    </div>
{/if}
{#each field.sections as section, index}
    <Section {simpleLanguage} bind:section path={[...path, index]} bind:state />
{/each}

<style lang="scss">
    div {
        max-width: 62.5rem;
        margin-bottom: 2.33rem;
        position: relative;

        h2 {
            font-size: 1.5rem;
            font-weight: 600;
            line-height: 1.39em;
            color: var(--color-text);

            span {
                color: var(--color-primary);
            }

            @media (min-width: 790px) {
                font-size: 2rem;
            }
        }

        p {
            padding-bottom: 1.5rem;
        }

        &.icon:before {
            content: '';
            position: absolute;
            background-color: var(--color-orange);
            width: 4.125rem;
            height: 4.125rem;
            left: -5.875rem;
            top: 0;
            mask-size: contain;
            mask-position: center;
            mask-repeat: no-repeat;
            mask-image: var(--icon);

            @media (max-width: 790px) {
                content: initial;
            }
        }
    }
</style>
